(()=>{
  const mount=()=>{
    const explorer=document.querySelector('[data-kpr-feature-explorer]');
    const gallery=document.querySelector('.kpr-retail-gallery');
    const accordions=document.querySelector('.kpr-retail-accordions');
    const qa=document.querySelector('[data-kpr-product-qa-host]');
    const summary=document.querySelector('.kpr-retail-summary');

    if(explorer&&gallery&&accordions&&accordions.parentElement!==gallery){
      explorer.insertAdjacentElement('afterend',accordions);
      accordions.classList.add('kpr-retail-accordions--below-features');
    }

    if(qa&&summary&&!summary.contains(qa))summary.appendChild(qa);
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});
  else mount();
  document.addEventListener('shopify:section:load',mount);
})();
